import { AppThunk } from '../../../../../store/types';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { getNativeLangCodeToTranslate, getNativeLanguage } from '../../../../../store/models/selectors';
import { ExercisesEffects } from '../../../../../effects/exercisesEffects';
import { EExerciseStatus, TCefrLevel, TExerciseAnswerValue } from '../../../../../../common/rest/exercises/exercisesRest';

export class ExercisesTabEvents {

	public static onLoad(): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(ExercisesEffects.load(audioId, getNativeLangCodeToTranslate(getState(), audioId)));
		}
	}

	public static onGenerate(promptId: number, level?: TCefrLevel): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(ExercisesEffects.generate(audioId, promptId, level));
		}
	}

	public static onAnswer(exerciseId: number, questionIndex: number, answer: TExerciseAnswerValue): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(ExercisesEffects.saveAnswer(audioId, exerciseId, questionIndex, answer));
		}
	}

	public static onClearAnswers(exerciseId: number, userId?: number): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(ExercisesEffects.clearAnswers(audioId, exerciseId, userId));
		}
	}

	public static onSetStatus(exerciseId: number, status: EExerciseStatus): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(ExercisesEffects.setStatus(audioId, exerciseId, status));
		}
	}

	public static onLoadNative(exerciseId: number): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			const nativeLangCode = getNativeLanguage(getState())?.code;
			if (audioId && nativeLangCode) dispatch(ExercisesEffects.loadNative(audioId, exerciseId, nativeLangCode));
		}
	}

	public static onLoadStudents(): AppThunk {
		return (dispatch, getState) => {
			const audioId = getCurrentAudioId(getState());
			if (audioId) dispatch(ExercisesEffects.loadStudents(audioId));
		}
	}

}
